var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoTransactions = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 114,
    viewBox: "0 0 139 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.169 6.9061C107.375 6.9061 106.732 7.54939 106.732 8.34292C106.732 9.13645 107.375 9.77974 108.169 9.77974C108.962 9.77974 109.605 9.13645 109.605 8.34292C109.605 7.54938 108.962 6.9061 108.169 6.9061ZM106.004 8.34292C106.004 7.14739 106.973 6.17822 108.169 6.17822C109.364 6.17822 110.333 7.14739 110.333 8.34292C110.333 9.53845 109.364 10.5076 108.169 10.5076C106.973 10.5076 106.004 9.53845 106.004 8.34292Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.168 4.09946C105.825 4.09946 103.925 5.99934 103.925 8.34296C103.925 10.6866 105.825 12.5865 108.168 12.5865C110.512 12.5865 112.412 10.6866 112.412 8.34296C112.412 5.99933 110.512 4.09946 108.168 4.09946ZM103.197 8.34296C103.197 5.59734 105.423 3.37158 108.168 3.37158C110.914 3.37158 113.14 5.59734 113.14 8.34296C113.14 11.0886 110.914 13.3143 108.168 13.3143C105.423 13.3143 103.197 11.0886 103.197 8.34296Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.168 0.727873C103.963 0.727873 100.553 4.13723 100.553 8.34288C100.553 12.5485 103.963 15.9579 108.168 15.9579C112.374 15.9579 115.783 12.5485 115.783 8.34288C115.783 4.13723 112.374 0.727873 108.168 0.727873ZM99.8254 8.34288C99.8254 3.73524 103.561 0 108.168 0C112.776 0 116.511 3.73524 116.511 8.34288C116.511 12.9505 112.776 16.6858 108.168 16.6858C103.561 16.6858 99.8254 12.9505 99.8254 8.34288Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5159 53.1013L121.647 26.4902V53.1013H33.6369",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M134.423 53.1013H31.5159V113.531H134.423V53.1013Z",
    fill: "#006EF5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5522 8.26159L57.5522 95.2832H108.383V8.26159H57.5522Z",
    fill: "#FFB257"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M108.384 53.158H57.5537V95.2814H108.384V53.158Z",
    fill: "#091F83"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1683 87.7698H73.7705C73.7705 82.3806 69.4019 78.0119 64.0098 78.0119V25.5308C69.4019 25.5308 73.7705 21.1621 73.7705 15.7729H92.1683C92.1683 21.1621 96.537 25.5308 101.929 25.5308V78.0119C96.537 78.0119 92.1683 82.3806 92.1683 87.7698Z",
    fill: "#F0F8FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0098 53.158V78.0105C69.4019 78.0105 73.7705 82.3792 73.7705 87.7683H92.1683C92.1683 82.3792 96.537 78.0105 101.929 78.0105V53.158H64.0098Z",
    fill: "#6BB6FB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6086 53.158C69.6086 45.7788 75.5903 39.7986 82.968 39.7986C90.3457 39.7986 96.3274 45.7802 96.3274 53.158",
    fill: "#6BB6FB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3289 53.158C96.3289 60.5371 90.3472 66.5173 82.9695 66.5173C75.5918 66.5173 69.6101 60.5357 69.6101 53.158",
    fill: "#006EF5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M138.452 77.8228H120.183V90.0205H138.452V77.8228Z",
    fill: "#6BB6FB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M134.423 77.8228H120.183V90.0205H134.423V77.8228Z",
    fill: "#091F83"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M127.301 87.6198C129.343 87.6198 130.999 85.9643 130.999 83.9222C130.999 81.8801 129.343 80.2246 127.301 80.2246C125.259 80.2246 123.604 81.8801 123.604 83.9222C123.604 85.9643 125.259 87.6198 127.301 87.6198Z",
    fill: "#FFCEC2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5159 107.252H134.421V107.834H31.5159V107.252Z",
    fill: "#F0F8FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5159 99.26V65.8608L54.1411 82.5597L31.5159 99.26Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4504 74.0493H0.547852V89.2779H31.4504V74.0493Z",
    fill: "#FFCEC2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6771 40.6198L82.9375 54.2857L77.4255 48.8421L78.3462 47.9099L82.9342 52.441L95.7532 39.6909L96.6771 40.6198Z",
    fill: "#232323"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoTransactions);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/NoTransactions.b5f746a2e5c3a9fc0b8a93f5845861d5.svg";